import styled from 'styled-components';

export const Page = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;
